import { ProductEmailRequest, ProductEmailType } from '@Portal/legacy/types';
import { useAxios } from '@Shared/composables/useAxios';
import { usePortalUri } from '@Shared/composables/usePortalUri';
import { AuthToken } from '@Shared/types/auth';
import { SsoAuthRequestPostParameters } from '@Shared/types/portal/PortalSettings';
import { AuthServerUserUpdateModel, CurrentUserDetail } from '@Shared/types/portal/UserInfo';
import { AxiosError } from 'axios';

export const getCurrentUser = async () => {
  const portalUri = usePortalUri();
  const axios = useAxios();
  const response = await axios.get<CurrentUserDetail>(`${portalUri}/api/identity/me`);
  return response.data;
};

export const getSsoAuthRequestPostParameters = async () => {
  const portalUri = usePortalUri();
  const axios = useAxios();
  const response = await axios.post<SsoAuthRequestPostParameters>(`${portalUri}/api/sso/authRequest`, {});
  return response.data;
};

export const requestPasswordReset = async (username: string) => {
  const portalUri = usePortalUri();
  const axios = useAxios();
  await axios.post(`${portalUri}/api/identity/requestResetPassword`, JSON.stringify(username));
};

export const resetPassword = async (
  token: string,
  oldPassword: string,
  newPassword: string,
  confirmPassword: string
) => {
  const portalUri = usePortalUri();
  const axios = useAxios();
  await axios.post(`${portalUri}/api/identity/resetpassword/` + token, {
    oldPassword,
    newPassword,
    confirmPassword,
  });
};

export const login = async (username: string, password: string): Promise<AuthToken | string> => {
  const portalUri = usePortalUri();
  const axios = useAxios();
  try {
    const result = await axios.post<{ content: AuthToken; isSuccess: boolean; message: string }>(
      `${portalUri}/api/identity/token`,
      {
        username,
        password,
      }
    );
    if (!result.data.isSuccess) return result.data.message;
    return result.data.content;
  } catch (e: any) {
    const err = e as AxiosError;
    return err.response?.data as string;
  }
};

export const getUserByOtpToken = async (token: string): Promise<AuthServerUserUpdateModel | undefined> => {
  const portalUri = usePortalUri();
  const axios = useAxios();
  try {
    const result = await axios.get<AuthServerUserUpdateModel>(`${portalUri}/api/identity/otpWho/` + token);
    return result.data;
  } catch (e: any) {
    const err = e as AxiosError;
    if (err.response && err.response.status == 400) {
      return undefined;
    } else {
      throw err;
    }
  }
};

export const requestCustomerJourneyAccess = async (clickedProgram: string) => {
  const portalUri = usePortalUri();
  const axios = useAxios();
  const requestApi = `${portalUri}/api/identity/requestTrial`;
  const request = {
    ProgramName: clickedProgram,
    ProductEmailType: ProductEmailType.CustomerJourney,
  } as ProductEmailRequest;
  await axios.post(requestApi, request);
};

export const requestBenchmarkAccess = async (clickedProgram: string) => {
  const portalUri = usePortalUri();
  const axios = useAxios();
  const requestApi = `${portalUri}/api/identity/requestTrial`;
  const request = {
    ProgramName: clickedProgram,
    ProductEmailType: ProductEmailType.Benchmarking,
  } as ProductEmailRequest;
  await axios.post(requestApi, request);
};
